import React, { createContext, useCallback, useContext, useState } from "react";

const LeadModalContext = createContext({
  open: false,
  mode: "demo_request",
  openModal: () => {},
  closeModal: () => {},
});

export function LeadModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("demo_request");

  const openModal = useCallback((nextMode = "demo_request") => {
    setMode(nextMode);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <LeadModalContext.Provider value={{ open, mode, openModal, closeModal }}>
      {children}
    </LeadModalContext.Provider>
  );
}

export function useLeadModal() {
  return useContext(LeadModalContext);
}
